import { ControlInterface } from 'edocatbase/Form';
import { Dispatch } from 'redux';
import { addAresField, getAresValues, removeAresField } from '../../../actions/form';
import ContactsModal from './ContactsModal';
import NewContactModal from './NewContactModal';
const { toggleModal } = window.Edocat.Components.ModalTest.actions;
import { is } from 'ramda';

const Input = window.Edocat.Components.TextField;
const { Button, InputAdornment } = window.Material;

interface TextFieldInterface extends ControlInterface {
	multiline: boolean;
	actions: any;
	formInstanceId: string;
	contactsModal: any;
	newContactModal: any;
}

class AresField extends React.PureComponent<TextFieldInterface> {
	onFieldChange = (event: React.ChangeEvent, index: number, key: string) => {
		event.preventDefault();
		const { onChange, name, dirty } = this.props;
		const { value } = event.target as HTMLInputElement;
		onChange([name, 'value', index, key], value, dirty);
	};

	handleAddField = () => {
		const { actions, name, formInstanceId } = this.props;
		actions.addAresField(formInstanceId, name);
	};

	handleRemoveField = (index: number) => {
		const { actions, name, formInstanceId } = this.props;
		actions.removeAresField(formInstanceId, name, index);
	};

	handleValidateField = (index: number, ico: number | string) => {
		const { actions, formInstanceId, name } = this.props;
		actions.getAresValues(formInstanceId, name, index, ico);
	};

	onBlur = () => {
		const { onBlur, name, value, dirty } = this.props;
		// @ts-ignore
		onBlur(name, value, dirty);
	};

	handleContacts = (index: number) => {
		const { actions, formInstanceId, name } = this.props;
		actions.toggleModal(true, name, { index }, formInstanceId);
	};

	render() {
		const {
			autoFocus,
			disabled,
			value,
			control: {
				params: { forceEditable },
			},
			name,
			contactsModal,
			newContactModal,
			formInstanceId,
			className,
			mandatory,
			placeholder,
		} = this.props;

		let finalValue = value;

		if (is(String, value)) {
			try {
				finalValue = JSON.parse(value);
			} catch (e) {
				finalValue = [
					{
						aresError: false,
						companyName: '',
						contacts: [],
						dic: '',
						ico: '',
						street: '',
						town: '',
						zip: '',
					},
				];
			}
		}

		return (
			<React.Fragment>
				{finalValue.map((it: any, index: number) => {
					// Define warning message --> Simple validation as whole ARES is made quite fast and simple
					const important = !it?.ico || !Number(it?.ico) || it?.ico?.length !== 8;
					// Define helper Text
					let helperText: string = '';
					if (it?.aresError) helperText = 'Zadané IČO neexistuje';
					else if (!it?.ico) helperText = 'Prázdné IČO';
					else if (!Number(it?.ico) || it?.ico?.length !== 8)
						helperText = window.Alfresco.messages.global['Alfresco.forms.validation.invalid.message'];

					return (
						<div className="aresCompanySet--Edit" key={index}>
							{Object.keys(it).map((item: string, innerIndex: number) =>
								item !== 'contacts' && item !== 'aresError' ? (
									<div className={`form-row row-${name}`} key={`${index}${innerIndex}`}>
										<Input
											autoFocus={autoFocus}
											className={
												className +
												(item === 'ico' && (important || it?.aresError)
													? ' important validateAresFiled'
													: ' validateAresFiled')
											}
											type={item === 'ico' ? 'tel' : 'text'}
											helperText={item === 'ico' && helperText}
											important={item === 'ico' && (important || it?.aresError) ? helperText : ''}
											disabled={forceEditable ? false : disabled}
											label={window.Alfresco.messages.global[`edocat.forms.${item}`]}
											mandatory={mandatory}
											name={name}
											onBlur={this.onBlur}
											onChange={(event: React.ChangeEvent) => this.onFieldChange(event, index, item)}
											value={it?.[item]}
											placeholder={placeholder}
											endAdornment={
												item === 'ico' && (
													<InputAdornment position="end">
														<Button
															color="primary"
															variant="contained"
															size="small"
															disabled={important}
															onClick={() => this.handleValidateField(index, it?.ico)}
															disableElevation
														>
															Validovat vůči ARES
														</Button>
													</InputAdornment>
												)
											}
										/>
									</div>
								) : null
							)}
							<div className={`form-row row-${name}`}>
								<label>Kontakty:</label>
								<span>
									<Button disableElevation variant="outlined" onClick={() => this.handleContacts(index)} size="small">
										Zobrazit tabulku
									</Button>
								</span>
							</div>
							<div className={`form-row row-${name}`}>
								{finalValue.length > 1 && (
									<Button
										color="primary"
										variant="outlined"
										disabled={value?.length === 1}
										onClick={() => this.handleRemoveField(index)}
										disableElevation
									>
										Smazat společnost
									</Button>
								)}
								{finalValue.length - 1 === index && (
									<Button disableElevation variant="contained" color="primary" onClick={this.handleAddField}>
										Přidat společnost
									</Button>
								)}
							</div>
						</div>
					);
				})}
				{contactsModal.isOpen && (
					<ContactsModal {...{ index: contactsModal?.items?.index, name, value, contactsModal, formInstanceId }} />
				)}
				{newContactModal.isOpen && (
					<NewContactModal {...{ index: contactsModal?.items?.index, name, newContactModal, formInstanceId }} />
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any, props: any) => {
	const contactsModal = state?.[props.formInstanceId]?.formModal?.[props.name] || {};
	const newContactModal = state?.[props.formInstanceId]?.formModal?.newContactModal || {};
	return {
		contactsModal,
		newContactModal,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: window.redux.bindActionCreators({ addAresField, getAresValues, toggleModal, removeAresField }, dispatch),
});

export default window.reactRedux.connect(mapStateToProps, mapDispatchToProps)(AresField);
